import T from "utils/T";

const WEEK_DAY_COLUMNS = [
  T('월'),
  T('화'),
  T('수'),
  T('목'),
  T('금'),
  T('토'),
  T('일'),
];

export default WEEK_DAY_COLUMNS;